import {Check} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {useI18n} from '@/i18n'
import {MutedText} from '@/components/shared/MutedText'
import {OutboundConnectorType} from '@/types/outbound-connector'
import type {OutboundConnectorTestResult} from '@/types/outbound-connector'

interface ConnectorTestDialogProps {
    open: boolean
    onClose: () => void
    testResult: OutboundConnectorTestResult | null
    connectorType: string
    testId?: string
}

export function ConnectorTestDialog({open, onClose, testResult, connectorType, testId}: ConnectorTestDialogProps) {
    const i18n = useI18n()

    return (
        <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose() }}>
            <DialogContent data-testid={testId}>
                <DialogHeader>
                    <DialogTitle>{i18n.connectors.testResultTitle}</DialogTitle>
                </DialogHeader>
                <div className="py-4">
                    {testResult && (
                        <div className="items-center gap-4">
                            <div className="h-12 w-12 rounded-full bg-status-success-subtle flex items-center justify-center">
                                <Check className="h-6 w-6 text-status-success"/>
                            </div>
                            <div>
                                <p className="font-medium text-status-success">{i18n.connectors.connectionSuccess}</p>
                                <MutedText size="sm">
                                    {connectorType === OutboundConnectorType.SCIM_2_0
                                        ? i18n.connectors.connectionSuccessMessage({statusCode: String(testResult.statusCode)})
                                        : i18n.connectors.connectionSuccessMessageGeneric}
                                </MutedText>
                            </div>
                        </div>
                    )}
                </div>
                <DialogFooter>
                    <Button data-testid="btn-close-test-result" onClick={onClose}>{i18n.common.close}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
